/* tslint:disable */
import {
  Game
} from '../index';

declare var Object: any;
export interface RewardInterface {
  "type": string;
  "title": string;
  "description"?: string;
  "url"?: string;
  "expirationTime"?: Date;
  "thumbnail": any;
  "background"?: any;
  "counter"?: any;
  "coinIcon"?: string;
  "points"?: number;
  "surveyOnly"?: boolean;
  "gameId": any;
  "id"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  game?: Game;
}

export class Reward implements RewardInterface {
  "type": string;
  "title": string;
  "description": string;
  "url": string;
  "expirationTime": Date;
  "thumbnail": any;
  "background": any;
  "counter": any;
  "coinIcon": string;
  "points": number;
  "surveyOnly": boolean;
  "gameId": any;
  "id": any;
  "createdAt": Date;
  "updatedAt": Date;
  game: Game;
  constructor(data?: RewardInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Reward`.
   */
  public static getModelName() {
    return "Reward";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Reward for dynamic purposes.
  **/
  public static factory(data: RewardInterface): Reward{
    return new Reward(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Reward',
      plural: 'rewards',
      path: 'rewards',
      idName: 'id',
      properties: {
        "type": {
          name: 'type',
          type: 'string'
        },
        "title": {
          name: 'title',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "url": {
          name: 'url',
          type: 'string'
        },
        "expirationTime": {
          name: 'expirationTime',
          type: 'Date'
        },
        "thumbnail": {
          name: 'thumbnail',
          type: 'any'
        },
        "background": {
          name: 'background',
          type: 'any'
        },
        "counter": {
          name: 'counter',
          type: 'any'
        },
        "coinIcon": {
          name: 'coinIcon',
          type: 'string'
        },
        "points": {
          name: 'points',
          type: 'number'
        },
        "surveyOnly": {
          name: 'surveyOnly',
          type: 'boolean',
          default: true
        },
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
      }
    }
  }
}
